<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaGrupos(empresaSelecionada)"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">GRUPOS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogoGrupo = true" tile color="#3BA8A2">
                <v-icon left dark>add_circle</v-icon>Cadastrar
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom v-if="user.tipo == 'ADMIN'">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon :color="item.ativo == true ? 'success' : 'error'">mdi-circle</v-icon>
          </template>
          <template v-slot:no-data>
            <v-row style="margin: 0px">
              <v-col>
                <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dark dense text outlined color="info" icon="info" style="margin: 0px">Selecione uma empresa para visualizar os painéis</v-alert>
                <v-alert v-if="empresaSelecionada" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum grupo cadastrado</v-alert>
                <v-alert v-if="user.tipo != 'ADMIN'" dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum grupo cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoGrupo" persistent max-width="500px">
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 10px; padding-top: 10px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Nome*"
                outlined
                dense
                hide-details
                v-model="editedItem.tipoPessoa"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="Código*"
                outlined
                dense
                hide-details
                v-model="editedItem.controlId"
                type="tel"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoGrupo = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarGrupo" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn text color="success" @click="editarGrupo" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Tipo', align: 'start', value: 'tipoPessoa', },
          { text: 'Código Inicial', value: 'controlId' },
          // { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogoGrupo: false,
      editedIndex: -1,
      editedItem: {
        tipoPessoa: '',
        controlId: '',
        empresaId: '',
      },
      defaultItem: {
        tipoPessoa: '',
        controlId: '',
        empresaId: '',
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo grupo' : 'Editar grupo'
      },
    }),

    watch: {
      dialogoGrupo(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaGrupos(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaGrupos(this.companyobj.id)
      }
      
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaGrupos(id) {
        this.tabela.conteudo = []
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Grupos?filter={"where":{"empresaId":"' + id + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoGrupo = true
        this.isLoading = false
      },

      async salvarGrupo() {
        var vm = this;

        if (!this.editedItem.tipoPessoa || !this.editedItem.controlId) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        }
        else {
          this.isLoading = true
          this.editedItem.empresaId = this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.companyobj.id

          await axios.post(baseApiUrl + 'Grupos/criar?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              if (response.data) {
                this.dialogoGrupo = false
                vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
                this.carregaGrupos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
              }
            }
          })
          .catch(error => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#FF0000", "Problema ao realizar operação, tente novamente. (" + error.response.data.error.message + ")", "DESCULPE")
          })
          this.isLoading = false
        }
      },

      async editarGrupo() {
        var vm = this;

        if (!this.editedItem.nome || !this.editedItem.deviceId || !this.editedItem.tipo || !this.editedItem.funcao ||
            !this.editedItem.ip  || !this.editedItem.porta || !this.editedItem.usuario || !this.editedItem.senha
        ) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
        else {
          this.isLoading = true

          await axios.put(baseApiUrl + 'Grupos/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoGrupo = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaGrupos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
            }           	
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o grupo ' + item.nome + '?')

        if (r == true) {
          await axios.delete(baseApiUrl + 'Grupos/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {    
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaGrupos(this.empresaSelecionada ? this.empresaSelecionada : this.companyobj.id)
          })
        }
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>